import api from "./index";

// ========== 客户试剂额度 ==========

// 分页搜索客户（按手机号/客户名/设备编码）
export function searchCustomerQuotaPage(params) {
    return api.post("/web/reagent-quota/customer/page", params);
}

// 根据客户ID+设备查询13种试剂额度
export function getCustomerQuotaById(customerId, deviceId, deviceName) {
    return api.get("/web/reagent-quota/list", { params: { customerId, deviceId, deviceName } });
}

// 批量分配试剂额度
export function allocateReagentQuota(data) {
    return api.post("/web/reagent-quota/allocate", data);
}
